import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'processed_food'

const answers: AnswerType[] = [
  {
    emoji: '🌭',
    title: 'pages.onboarding.processedFood.options.daily',
    value: 'daily',
  },
  {
    emoji: '🍔',
    title: 'pages.onboarding.processedFood.options.twoToThreeTimesAWeek',
    value: 'often',
  },
  {
    emoji: '🍕',
    title: 'pages.onboarding.processedFood.options.onceAWeek',
    value: 'sometimes',
  },
  {
    emoji: '🥗',
    title: 'pages.onboarding.processedFood.options.rarely',
    value: 'rarely',
  },
]

export default function ProcessedFoodPage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && answers.some((answer) => answer.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const input = event.target as HTMLInputElement
    const value = input.value

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How often do you eat processed foods?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.processedFood.heading"
      onSubmit={onSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
